import { Navigate, RouteObject } from 'react-router-dom';
import { PublicAnalyticsPage } from './pages/public-analytics.page';
import { AnalyticsRoutes } from './constants';
import { AuthRoutes } from '../auth';

export const AnalyticsModuleRouter: RouteObject[] = [
	{
		path: AnalyticsRoutes.Root,
		element: <PublicAnalyticsPage />,
		handle: {
			title: 'nav.analytics',
			needsDrawer: false,
			fullWidth: true,
		},
	},
	{
		index: true,
		element: <Navigate to={AuthRoutes.LoginEmail} replace />,
	},
];
